import { useContext } from 'react';
import CustomButton from '../../CustomButton';
import { FileContext } from '../../../context/FileContext';

const LineItemsControllers = ({ t }) => {
  const { setShowLineItemModal } = useContext(FileContext);

  return (
    <>
      <CustomButton size="small" onClick={() => setShowLineItemModal(true)}>
        {t('Configure sub item')}
      </CustomButton>
    </>
  );
};

export default LineItemsControllers;
